(() => {
  if (window.youtubeVideoCoordinator) return;

  const groupStates = new Set();
  let apiPromise;

  function pauseIframe(iframe) {
    iframe.contentWindow?.postMessage(JSON.stringify({
      event: 'command',
      func: 'pauseVideo',
      args: [],
    }), '*');
  }

  function pauseOutside(state, activeSlide) {
    state.iframes.forEach((iframe) => {
      if (!activeSlide?.contains(iframe)) pauseIframe(iframe);
    });
  }

  function pauseOtherPlayers(state, activePlayer) {
    state.players.forEach((player) => {
      if (player !== activePlayer && typeof player.pauseVideo === 'function') {
        player.pauseVideo();
      }
    });
  }

  function loadYouTubeApi() {
    if (window.YT?.Player) return Promise.resolve(window.YT);
    if (apiPromise) return apiPromise;

    apiPromise = new Promise((resolve, reject) => {
      let script = document.querySelector('script[src="https://www.youtube.com/iframe_api"]');

      if (!script) {
        script = document.createElement('script');
        script.src = 'https://www.youtube.com/iframe_api';
        script.async = true;
        document.head.appendChild(script);
      }

      script.addEventListener('error', () => reject(new Error('Unable to load YouTube iframe API')), { once: true });

      let attempts = 0;
      const waitForApi = window.setInterval(() => {
        attempts += 1;
        if (window.YT?.Player) {
          window.clearInterval(waitForApi);
          resolve(window.YT);
        } else if (attempts >= 100) {
          window.clearInterval(waitForApi);
          reject(new Error('YouTube iframe API did not become ready'));
        }
      }, 50);
    });

    return apiPromise;
  }

  async function initializePlayers(state) {
    if (state.playersInitialized) return;
    state.playersInitialized = true;

    try {
      const YT = await loadYouTubeApi();

      state.iframes.forEach((iframe) => {
        if (iframe.closest('.slick-cloned')) return;

        const player = new YT.Player(iframe, {
          events: {
            onStateChange(event) {
              if (event.data === YT.PlayerState.PLAYING) {
                pauseOtherPlayers(state, event.target);
              }
            },
          },
        });
        state.players.add(player);
      });
    } catch (error) {
      state.playersInitialized = false;
      console.error('YouTube video coordinator:', error);
    }
  }

  function bindSlick(state) {
    const slider = state.group.matches('[data-slick-slider]')
      ? state.group
      : state.group.querySelector('[data-slick-slider]');

    if (!slider || slider.dataset.youtubeCoordinatorBound === 'true') return;
    if (!window.jQuery?.fn?.slick || !slider.classList.contains('slick-initialized')) return;

    slider.dataset.youtubeCoordinatorBound = 'true';
    window.jQuery(slider).on('beforeChange.youtubeVideoCoordinator', (_event, slick, _current, next) => {
      pauseOutside(state, slick.$slides.get(next));
    });
  }

  function setupGroup(group) {
    if (group.dataset.youtubeCoordinatorReady === 'true') return;

    const iframes = Array.from(group.querySelectorAll('iframe[data-youtube-player]'));
    if (!iframes.length) return;

    group.dataset.youtubeCoordinatorReady = 'true';
    const state = {
      group,
      iframes,
      players: new Set(),
      playersInitialized: false,
    };
    groupStates.add(state);

    const slideshow = group.matches('slideshow-component')
      ? group
      : group.querySelector('slideshow-component');

    slideshow?.addEventListener('slideChanged', (event) => {
      pauseOutside(state, event.detail.currentElement);
    });

    bindSlick(state);

    if (typeof IntersectionObserver === 'function') {
      const observer = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        observer.disconnect();
        initializePlayers(state);
      }, { rootMargin: '300px 0px' });
      observer.observe(group);
    } else {
      initializePlayers(state);
    }
  }

  function initializeGroups(scope = document) {
    if (scope.matches?.('[data-youtube-video-group]')) setupGroup(scope);
    scope.querySelectorAll?.('[data-youtube-video-group]').forEach(setupGroup);
  }

  document.addEventListener('DOMContentLoaded', () => initializeGroups(), { once: true });
  document.addEventListener('shopify:section:load', (event) => initializeGroups(event.target));
  document.addEventListener('theme:slick-ready', () => groupStates.forEach(bindSlick));

  window.youtubeVideoCoordinator = { initializeGroups };
})();
